import { render, staticRenderFns } from "./EuropeanSanctionListDialog.vue?vue&type=template&id=20b5d960&"
import script from "./EuropeanSanctionListDialog.vue?vue&type=script&lang=js&"
export * from "./EuropeanSanctionListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
